module.exports = __webpack_public_path__ + "img/pig-face.7f21b468.png";